module.exports = __webpack_public_path__ + "img/pic-other.00bffa9b.jpg";